import React from 'react';
import { Box, Typography } from 'web-library';
import { useTranslation } from 'react-i18next';
import { Theme as AugmentedTheme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import { typographyTheme } from "web-library/theme/helper/tssHelper"

const useStyles = makeStyles()((theme) =>
({
  label: {
     ...typographyTheme(theme, 'subtitle2'),
    color: theme.color.text.textHeader,
  },
  secondTimerFeeContainer: {
    paddingTop: theme.spacing(2),
  },
}));

interface SpersFeeDetailProps {
  firstTimerFee: number;
  secTimerFee: number;
}

const SpersFeeDetail = ({ firstTimerFee, secTimerFee }: SpersFeeDetailProps) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <>
      <Box>
        <Typography className={classes.label}>
          {t('exam->>ExamFeeConfiguration.FirstTimer')}{' '}
        </Typography>
        <Typography variant="body2">${firstTimerFee.toFixed(2)}</Typography>
      </Box>
      <Box className={classes.secondTimerFeeContainer}>
        <Typography className={classes.label}>
          {t('exam->>ExamFeeConfiguration.SecTimer')}{' '}
        </Typography>
        <Typography variant="body2">${secTimerFee.toFixed(2)}</Typography>
      </Box>
    </>
  );
};

export default SpersFeeDetail;
